import React from "react";
import ReactDOM from "react-dom";
import { ConfirmModalProps } from "./ConfirmModal.types";
import {
  CloseButton,
  Divider,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  AgreementLinks,
  AgreementLink,
} from "./ConfirmModal.styles";
import Button from "../../Buttons/Button";
import { closeIcon as CloseIcon } from "assets/icons";

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmButtonText = "Удалить",
  confirmVariant = "primary",
  showAgreementLinks = false,
}) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <ModalOverlay>
      <ModalContent>
        <ModalHeader>
          <h2>{title}</h2>
          <CloseButton aria-label="Закрыть" onClick={onCancel}>
            <CloseIcon aria-hidden="true" />
          </CloseButton>
        </ModalHeader>
        <Divider />
        <ModalBody>
          <p>{message}</p>
          {showAgreementLinks && (
            <AgreementLinks>
              <AgreementLink
                href="/Лицензионное соглашение на использование платформы «ЛИСРЕНТ».docx"
                target="_blank"
                rel="noopener noreferrer"
              >
                Лицензионное соглашение на использование платформы «ЛИСРЕНТ»
              </AgreementLink>
              <AgreementLink
                href="/Пользовательское соглашение платформы LISRENT.docx"
                target="_blank"
                rel="noopener noreferrer"
              >
                Пользовательское соглашение платформы LISRENT
              </AgreementLink>
            </AgreementLinks>
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={onCancel}>
            Отмена
          </Button>
          <Button variant={confirmVariant} onClick={onConfirm}>
            {confirmButtonText}
          </Button>
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>,
    document.body,
  );
};

export default ConfirmModal;
